import React, { forwardRef, Fragment, useState, useEffect } from "react";
// import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import { TransitionProps } from "@mui/material/transitions";
// import UnitsConfiguration from "./UnitsConfiguration";
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import { Box, Modal } from "@mui/material";
import UnitsConfiguration from "./Units/UnitsConfiguration";

const style={
  bgcolor: "white",
  width:'100%',
  height: '100%',
  overflow: "scroll"
}

const Transition = forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function ShowUnitsConfiguration(props: {
  showDialog: boolean;
  handleClose: Function;
}) {
  const [open, setOpen] = useState(props.showDialog);

  const handleClose = () => {
    props.handleClose();
    setOpen(false);
  };

  useEffect(() => {
    const close = (e) => {
      if(e.keyCode === 27){
        return;
      }
    }
    window.addEventListener('keydown', close)
  return () => window.removeEventListener('keydown', close)
},[])

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        sx={{bgcolor: 'white'}}
      >
        <Fragment>
          <Box sx={style}>
        <AppBar sx={{ position: "relative" }}>
          <Toolbar>
            <IconButton
            edge='start'
            color='inherit'
            aria-label='close'
            onClick={handleClose}>
               <KeyboardDoubleArrowLeftIcon fontSize="large"/>
            </IconButton>
            <Typography sx={{ ml: 6, flex: 1 }} variant="h6" component="div">
              Project Units
            </Typography>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <UnitsConfiguration />
        </Box>
        </Fragment>
        
      </Modal>
    </div>
  );
}
